<template>
  <div class="dialog">
    <el-dialog :visible.sync="visible" center width="530px" destroy-on-close :auto-upload="false" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false">
      <el-image class="login_title_img" src="/static/img/login_title.png"></el-image>
      <el-input class="input" v-model="user" placeholder="账号" @keyup.enter.native="tologin"></el-input>
      <el-input class="input" v-model="pwd" placeholder="密码" type="password" @keyup.enter.native="tologin"></el-input>
      <div class="verifyDiv">
        <el-input class="input" v-model="verifyCode" placeholder="输入验证码" @keyup.enter.native="tologin"></el-input>
        <div class="imgDiv">
          <el-image :src="verifyUrl" @click="getImgVerify"></el-image>
        </div>
      </div>
      <el-button class="button" type="info" :disabled="this.verifyFail()" @click="tologin()">登录</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'

let Timer = null
let PostTimer = null

export default {
  data() {
    return {
      URL_PATH: URL_PATH,
      visible: false,
      verifyUrl: '',
      user: '',
      pwd: '',
      verifyCode: '',
      verifyKey: '',
      loginDisabled: true
    }
  },
  methods: {
    show() {
      this.visible = true
      this.getImgVerify()
    },
    close() {
      this.visible = false
    },
    getImgVerify() {
      this.$api
        .getImgVerify({})
        .then(({ data }) => {
          this.verifyUrl = data.Data.base64
          this.verifyKey = data.Data.key
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    verifyFail() {
      return this.user.length == 0 || this.pwd.length == 0 || this.verifyCode.length != 5
    },
    tologin() {
      if (this.verifyFail()) {
        return
      }
      this.$api
        .login({
          user: this.user,
          passwd: this.pwd,
          imgCode: this.verifyCode,
          imgKey: this.verifyKey
        })
        .then(({ data }) => {
          localStorage.setItem('token', data.Data.token)
          this.$emit('loginSuc')
          this.close()
        })
        .catch(({ error }) => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.input {
  margin-top: 40px;
  width: 480px;
}
.button {
  margin: 30px 0;
  width: 480px;
}
.verifyDiv {
  margin-top: 20px;
  width: 480px;
  display: inline-block;
  .input {
    width: 190px;
    float: left;
    margin: 10px 0px 0px 0px;
  }
  .imgDiv {
    width: 250px;
    height: 62px;
    float: left;
    margin-left: 40px;
  }
}
.upload-wrap {
  text-align: center;
}

.tips {
  font-size: 16px;
  line-height: 1;
  text-align: center;
  color: #000000;
  margin-bottom: 35px;
}
</style>

<style lang="less">
.el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 0px;
}
.el-button--info {
  color: #fff;
  background-color: #478ce9;
  border-color: #478ce9;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/loginDialog.vue